import { useEffect } from 'react';

type Props = {
  enabled?: boolean;
};

const MatomoTagManager = ({ enabled }: Props) => {
    useEffect(() => {
        if (!enabled) return;

        window._mtm = window._mtm || [];
        window._mtm.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start',
        });

        const script = document.createElement('script');
        script.src = process.env.REACT_APP_MATOMO_CONTAINER_URL as string;
        script.async = true;
        document.head.appendChild(script);

    }, [enabled]);

    return null;
};
export default MatomoTagManager;